/**
 * page : 측량 견적 문의 detail
 */

import { useEffect, useState, useConfirm } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as zy from '../common/zeroyear-1.0.0';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import { MDBRipple } from 'mdb-react-ui-kit';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Swal from "sweetalert2";
import '../assets/css/card.css'
let sessionStorage = window.sessionStorage;

const dataObject = {PERF_SEQ: '', PERF_NO: '', PERF_DV: '20', PERF_CONSTR_NM: '', REG_DTM: '', PERF_CONTENT: '', PERF_IMG: ''};
export default function PerfGeneralDetail () {
    const [admin, setAdmin] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [perf, setPerf] = useState({});
    const [perfImg, setPerfImg] = useState([]);
    const [editImgs, setEditImgs] = useState([]);
    const [data, setData] = useState(dataObject);
    const [showModal, setShowModal] = useState(false);
    const [validated, setValidated] = useState(false);
    const selectAll = () => {
        zy.select('selectPerf', ['20', id],(itemA) => {
            zy.select('selectPerfImgOne', ['20', id], (itemB) => {
                setPerfImg(itemB);
                setPerf(itemA[0]);
                setData({...data, PERF_SEQ: id});
                setEditImgs(itemB.map((img, index) => { return { id: index+1, img: img.PERF_IMG, PERF_IMG_SEQ: img.PERF_IMG_SEQ, PERF_IMG_NO: img.PERF_IMG_NO, PERF_SEQ: img.PERF_SEQ } }));
                setLoading(false);
            });
        });
    };
    useEffect(()=>{
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    }, []);
    /**
     * close modal 수정하기
     */
    const closeModal = () => {
        setValidated(false);
        setShowModal(false);
        selectAll();
    };
    /**
     * open modal 수정하기
     */
    const openModal = () => {
        setValidated(false);
        setShowModal(true);
        setData({...data, PERF_NO: perf.PERF_NO, PERF_DV: perf.PERF_DV, REG_DTM: perf.REG_DTM, PERF_CONSTR_NM: perf.PERF_CONSTR_NM, PERF_CONTENT: perf.PERF_CONTENT, DEPT_NM: perf.DEPT_NM});
    };
    /**
     * 목록 이동
     */
    const locateList = () => {
        navigate('/PerfGeneral');
    }

    /**
     * 작성자 change event
     */
    const changeRegNm = (event) => {
        setData({...data, PERF_CONSTR_NM: event?.target.value});
    }
    const savePerf = (event) => {
        let queryId = '';
        let params = [];
        if (perf.PERF_DV !== data.PERF_DV) {
            queryId = 'updatePerfNo';
            params = [ data.PERF_DV, data.PERF_DV, data.PERF_CONSTR_NM, data.DEPT_NM, data.NECESS_PRID, data.PERF_CONTENT, data.PERF_SEQ];
        } else {
            queryId = 'updatePerf';
            params = [ data.PERF_CONSTR_NM, data.DEPT_NM, data.NECESS_PRID, data.PERF_CONTENT, data.PERF_SEQ];
        }
        zy.modify(queryId, params, (item) => {
            if (item.affectedRows > 0) {
                // 이미지 dv 수정
                zy.modify('updatePerfImgDv', [
                    data.PERF_DV, data.PERF_SEQ
                ], (itemB) => {
                    let url = '';
                    switch (data.PERF_DV) {
                        case '10': url = 'PerfPointDetailRoute'; break;
                        case '20': url = 'PerfGeneralDetailRoute'; break;
                        case '30': url = 'PerfCivilDetailRoute'; break;
                        case '40': url = 'PerfEtcDetailRoute'; break;
                    }
                    // 저장 완료
                    closeModal();
                    navigate(`/${url}/${data.PERF_SEQ}`);
                });
            }
        });
    }
    /**
     * 수정 event handler
     */
    const saveDesign = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            // validate
            event.preventDefault();
            event.stopPropagation();
        } else {
            // 저장
            event.preventDefault();
            event.stopPropagation();
            if (editImgs.filter((img) => img.DEL_YN !== 'Y').length == 0) {
                Swal.fire({
                    icon: "error",
                    text: "이미지를 등록해주세요.",
                }).then((res) => {
                    if (res.isConfirmed) { return false; }
                    else{ }
                });
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            editImgs.forEach((img, iidx) => {
                if (img.NEW_YN === 'Y') {
                    zy.create('insertPerfImg', [
                        img.PERF_SEQ, img.PERF_SEQ, img.PERF_DV, img.PERF_DV, img.img
                    ], (item) => {

                    });
                } else if (img.DEL_YN === 'Y') {
                    zy.destroy('deletePerfImg', [
                        img.PERF_IMG_SEQ, img.PERF_SEQ, img.PERF_IMG_NO 
                    ], (item) => {});
                }
                if (iidx+1 ==  editImgs.length) {
                    savePerf();
                }
            });
        }
        setValidated(true);
    };
    /**
     * 시공명칭 change event
     */
    const changePerfConstr = (event) => {
        setData({...data, PERF_CONSTR_NM: event?.target.value});
    }
    /**
     * 부서 change event
     */
    const changeDeptNm = (event) => {
        setData({...data, DEPT_NM: event?.target.value});
    }
    /**
     * 분류 change event
     */
    const changeDv = (event) => {
        setData({...data, PERF_DV: event?.target.value});
    }
    /**
     * 제목 change event
     */
    const changeNecess = (event) => {
        setData({...data, NECESS_PRID: event?.target.value});
    }
    /**
     * 내용 change event
     */
    const changeContent = (event) => {
        setData({...data, PERF_CONTENT: event?.target.value});
    }
    /**
     * 이미지 파일 change event
     */
    const changeImage = (event) => {
        let reader = new FileReader();
        if (event.target.files[0].size > 2621440) {
            event.target.value = "";
            Swal.fire({
                icon: "warning",
                title: "이미지 용량을 확인해주세요.",
                text: "이미지 용랑은 2.5MB 이하로 등록이 가능합니다.",
            }).then((res) => {
                if (res.isConfirmed) { }
                else{}
            });
            return false;
        } else {
            reader.readAsDataURL(event.target.files[0]);
        }
        reader.onload = function (e) {
            setEditImgs([...editImgs, { id: editImgs.length+1, img: e.target.result, PERF_SEQ: data.PERF_SEQ, PERF_DV: data.PERF_DV, NEW_YN: 'Y' }]);
        }
    }
    /**
     * 이미지 삭제
     */
    const deleteImage = (event) => {
        let index = editImgs.findIndex((o) => o.PERF_IMG_SEQ == event.target.dataset.key && o.PERF_IMG_NO == event.target.dataset.no && o.PERF_SEQ == event.target.dataset.seq);
        let arr = [...editImgs];
        if (index != -1) {
            arr[index] = {...arr[index], DEL_YN: 'Y'};
        }
        setEditImgs(arr);
    }
    /**
     * 실적 삭제
     */
    const deletePerf = () => {
        Swal.fire({
            icon: "warning",
            text: "삭제 하시겠습니까?",
            showCancelButton: true,
            confirmButtonText: '삭제',
            cancelButtonText: '취소',
            confirmButtonColor: '#cc1616',
        }).then((res) => {
            if (res.isConfirmed) {
                // img 전체 삭제
                zy.destroy('deletePerfImgAll', [
                    data.PERF_SEQ, data.PERF_DV
                ], (itemA) => {
                    // 목록 삭제
                    zy.destroy('deletePerf', [
                        data.PERF_SEQ, data.PERF_DV
                    ], (itemB) => { 
                        navigate('/PerfGeneral');
                    });
                });
             }
            else{ }
        });
        
    }
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">주요실적</a></li>
                        <li>일반측량</li>
                    </ol>
                    <h2>일반측량</h2>
                </div>
            </section>
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="row gy-4">
                        <Form>
                            <Form.Group className="mb-3" controlId="">
                                <Form.Label>글번호</Form.Label>
                                <Form.Control className="read-cont" type="text" defaultValue={perf.PERF_NO||''} readOnly disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="">
                                <Form.Label>시공명칭</Form.Label>
                                <Form.Control className="read-cont" type="text" defaultValue={perf.PERF_CONSTR_NM||''} readOnly disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="">
                                <Form.Label>작성일시</Form.Label>
                                <Form.Control className="read-cont" type="text" defaultValue={perf.REG_DTM||''} readOnly disabled/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="">
                                <Form.Label>이미지</Form.Label>
                                <Card className="text-center">
                                <Card.Header></Card.Header>
                                <Card.Body>
                                    <Card.Title></Card.Title>
                                        { perfImg.map((img, index) => {
                                            return (
                                                <div key={img.PERF_IMG_NO}>
                                                    <Image src={img.PERF_IMG} fluid />
                                                    {index+1 === perfImg.length ? null : <hr></hr>}
                                                </div>
                                            )
                                        })}
                                </Card.Body>
                                <Card.Footer className="text-muted"></Card.Footer>
                                </Card>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="">
                                <Form.Label>내용</Form.Label>
                                <Form.Control className="read-cont" as="textarea" rows={3} value={perf.PERF_CONTENT||''} readOnly disabled/>
                            </Form.Group>
                        </Form>
                    </div>
                    <div style={{float: 'right'}}>
                        <button className="btn-cancel" onClick={locateList}>목록</button>
                        { admin ? (
                            <>
                            <button className="btn-normal" onClick={openModal}>수정</button>
                            <button className="btn-delete" onClick={deletePerf}>삭제</button>
                            </>
                        ) : null }
                        
                    </div>
                </div>
            </section>

            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form>
                    <Modal.Header closeButton>
                    <Modal.Title>실적 수정</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="PERF_CONSTR_NM">
                            <Form.Label>시공명칭</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                onChange={changePerfConstr}
                                defaultValue={data.PERF_CONSTR_NM||''}
                                required/>
                            <Form.Control.Feedback type="invalid">시공명칭을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="PERF_CONSTR_NM">
                            <Form.Label>업무 담당부서</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                onChange={changeDeptNm}
                                defaultValue={data.DEPT_NM||''}
                                required/>
                            <Form.Control.Feedback type="invalid">업무 담당부서 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="PERF_CONSTR_NM">
                            <Form.Label>분류</Form.Label>
                            <Form.Select defaultValue={data.PERF_DV||''} onChange={changeDv}>
                                <option value="10">지적측량</option>
                                <option value="20">일반측량</option>
                                <option value="30">토목설계</option>
                                <option value="40">기타</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="PERF_CONSTR_NM">
                            <Form.Label>내용</Form.Label>
                            <Form.Control
                                as="textarea"
                                defaultValue={data.PERF_CONTENT||''}
                                onChange={changeContent}
                                rows={4}
                                required/>
                            <Form.Control.Feedback type="invalid">내용을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="Perf_TITLE">
                            <Form.Label>이미지 첨부</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/gif, image/jpeg, image/png"
                                onChange={changeImage}
                                placeholder=""
                                required/>
                            <Form.Control.Feedback type="invalid">이미지를 선택해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <div style={{marginBottom: '15px'}}>
                            <Row xs={2} md={4} className="g-4">
                                    {
                                        editImgs.map((perf) => {
                                            if (perf.DEL_YN !== 'Y') {
                                                return (
                                                    <Col key={perf.id}>
                                                        <Card className='perf-card'>
                                                            <div className="perf-cards">
                                                                <Card.Img variant="top" src={perf.img} className="perf-card-img-eidt w-100"/>
                                                                <button className='perf-card-del' data-key={perf.PERF_IMG_SEQ} data-no={perf.PERF_IMG_NO} data-seq={perf.PERF_SEQ} onClick={deleteImage}>X</button>
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                );
                                            } else {
                                                return null;
                                            }
                                        })
                                    }
                            </Row>
                        </div>
                        <Modal.Footer>
                            <button className="btn-cancel" type="button" onClick={closeModal}>닫기</button>
                            <button className="btn-normal" type="button" onClick={saveDesign}>저장</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
        </main>
        </>
    );
}